<footer class="footer left-footer">
    <div class="container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-12 col-sm-12 text-center">
                Copyright © 2024 <a href="javascript:void(0)">DigitoPay</a>. Todos os direitos reservados.
            </div>
        </div>
    </div>
</footer>
